<template>
  <div class="content">
    <loading v-if="loading" text='Loading. Please wait...'/>
    <div v-show="!loading">
      <h1>Learning Tools</h1>
      <span v-show="error" class="help is-danger">{{error}}</span>

      <!-- <div class="search">
        <span class="fal fa-search fa-lg"></span>
        <input type="text" name="search" v-model="search" placeholder="Search learning tools"/>
      </div> -->
      <Search v-on:searcher="onSearch" :placeholder="'Search learning tools'">
      </Search>

      <div v-if="searchedList.length === 0" class="no-content-message">
        There are currently no learning tools to display.
      </div>

      <div v-for="(tool, i) in searchedList" v-bind:key="i" class="list-item">
        <a :href="tool.url" target="_blank" @click="externalURLopen(tool.url)" class="learning-tool">
          <div class="img-middle">
            <img :src="tool.icon === 'default' ? $config.get('basePathFiles') + 'static/img/learning_tool_default_icon.png' : '/educator' + tool.icon" />
          </div> 
          <span>{{tool.name}}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  const _ = require('lodash');
  const moment = require('moment');
  require('moment-timezone');
  moment.tz.setDefault('Africa/Johannesburg');
  
  import Vue from 'vue'
  import utils from '@/utils/utils.js';
  import analytics from '@/utils/analytics.js';
  import Search from '@/components/widgets/Search';
  import storeHelpers from "@/utils/storeHelpers.js";
  
  export default {
    name: 'LearningTools',
    components: {
      Search
    },
    data: function () {
      var t = this;

      return {
       loading: true,
       tools: [],
       moment: moment,
       utils: utils,
       error: '',
       search: ''
      }
    },
    computed: {
      searchedList() {
        return _.orderBy(this.tools, [function(o) { return o.name.trim().toLowerCase() }], ['asc']).filter(tool => {
          return tool.name.toLowerCase().includes(this.search.toLowerCase())
        })
      }
    },
    destroyed: function() {
      this.unwatchFunction();
    },
    mounted: function () {
      storeHelpers.checkActive(this);
      this.unwatchFunction = utils.watchStoreProperty(this, 'services', this.learningToolsUpdated);
      analytics.learningTools(this);
    },
    methods: {
      learningToolsUpdated: function(tools) {
        this.tools = tools;

        _.each(this.tools, function(tool) {
          if(tool.url.indexOf('http') !== 0) {
            Vue.set(tool, 'url', 'http://' + tool.url);
          }
        });
        
        this.loading = false;
      },
      onSearch: function(val) {
        this.search = val;
      },
      externalURLopen: function(url) {
        // externalURLOpen: function(handle, url, location = 0)
        analytics.externalURLOpen(this, url, 3);
      }
    }
  }

</script>

<style scoped>
.search {
  margin-top: 30px;
}

.learning-tool {
  text-align: left;
  padding: 10px;
  height: 70px;
  display: block;
}

.learning-tool:hover {
  background: #eee;
  cursor: pointer;
}

.learning-tool span {
  margin-left: 10px;
  display: inline-block;
  vertical-align: top;
  margin-top: 12px;
}

.img-middle {
  width: 50px;
  height: 50px;
  display: inline-block;
  position: relative;
}

.img-middle img {
  max-height: 50px;
  width: 50px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
</style>